import Swiper from 'swiper/js/swiper';
import '~/sass/pages/search.scss';
import { verityInput, getSpecialTip } from '@/utils/util-extent';

const { $ } = window;

// eslint-disable-next-line no-unused-vars
let swiperSelect = null;

const selecetAll = () => {
  $('#show-all').on('click', function all() {
    $(this)
      .addClass('active')
      .parent('li')
      .siblings()
      .find('a')
      .removeClass('active');
    $('#search-result .tab-pane').addClass('active').addClass('show');
  });
  $('.scroll-menu a')
    .not('#show-all')
    .on('click', function others() {
      console.log(this.hash);
      $('#search-result .tab-pane').not(this.hash).removeClass('active').removeClass('show');
    });
};

const initSwiperSelect = () => {
  swiperSelect = new Swiper('.swiper-select .swiper-container', {
    slidesPerView: 'auto',
    slidesOffsetBefore: 10,
    slideToClickedSlide: true,
    normalizeSlideIndex: false,
    observer: true,
    observeParents: true,
    breakpoints: {
      768: {
        slidesOffsetBefore: 0,
        resistance: true,
        resistanceRatio: 0,
      },
    },
  });
};

selecetAll();
initSwiperSelect();

$(() => {
  $('#form').submit(() => {
    const $search = $('#form input[name=search]');
    if (verityInput($search.val(), 'htmltag') === false) {
      // eslint-disable-next-line no-alert
      alert(getSpecialTip());
      return false;
    }
    return true;
  });
});
